<template>
  <div id="app">
    <div
      class="wrapper"
      :class="{'pc': deviceType === config.DEVICE_PC, 'mobile': deviceType !== config.DEVICE_PC }"
    >
      <router-view :device-type="deviceType"></router-view>
      <div class="loading"></div>
    </div>
  </div>
</template>

<script>
import Config from "@/constants/config";
import { checkDeviceType } from "@/constants/util";

export default {
  name: "app",
  data() {
    return {
      config: Config,
      // deviceType: Config.DEVICE_WECHAT
      deviceType: checkDeviceType()
    };
  }
};
</script>

<style lang="scss">
$imgPath: "assets/images/";

html {
  font-family: "Arial","Microsoft YaHei","黑体","宋体",sans-serif !important;
}

.wrapper {
  background-color: #f3f3f3;
}

.broswer-tip {
  box-sizing: border-box;
  display: flex;
  position: fixed;
  top: 0;
  z-index: 99999999;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  line-height: 48px;
  padding: 7px 20px 7px 12px;
  background: #fef4db;
  color: #996b3d;
  font-size: 14px;
  font-weight: bold;

  .broswer-arrow {
    width: 13px;
    height: 16px;
    line-height: 16px;
    background-image: url($imgPath+"broswer-arrow.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
}
.img-screen {
  position: fixed;
  height: 90%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  margin: 20px auto 0 auto;
}
.img-modal {
  width: 100%;
  height: 100%;
  text-align: center;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 999999;
  background-color: #fff;
}
.screen-modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 9999999;
}
</style>
